import { createFileRoute } from '@tanstack/react-router';
import { choicesReadGuard } from '@bmwe/ui';
import { ChoiceTypeManagement } from '../../../features/choices/choiceTypeManagement';

export const Route = createFileRoute('/auswahlfelder/entscheidungsebenen/')({
  component: () => (
    <ChoiceTypeManagement
      choiceTypeKey="DecisionLevel"
      returnRoute="/auswahlfelder/decisionLevel"
    />
  ),
  beforeLoad: choicesReadGuard,
});

export const DecisionLevelRoute = Route;
